// import moment from 'moment';

import dateComparator from "./DateComparator";

import filterParams from "./DateFilter";

let cellClassRules = {
  "header-cell": "data.fk_id_examen === 6",
  acte_realise: "data.fk_id_examen === 5",
  acte_propose: "data.fk_id_examen === 4",
  motifCS: "data.fk_id_examen === 2",
  AV_SC: "data.fk_id_examen === 3",
  CO_PO: "data.fk_id_examen === 12",
  CO_FI: "data.fk_id_examen === 13",
  PIO: "data.fk_id_examen === 11",
  LAF: "data.fk_id_examen === 10",
  FO: "data.fk_id_examen === 9",
  ANGIO: "data.fk_id_examen === 8",
  OCT: "data.fk_id_examen === 7",
  NOTE: "data.fk_id_examen === 1",
  EXAM_COMPL: "data.fk_id_examen === 14",
  ORDO_MED: "data.fk_id_examen === 15",
};

let cellClassRulesODG = {
  "acte_realise_quarters-cell": "data.fk_id_examen === 5",
  "acte_propose_quarters-cell": "data.fk_id_examen === 4",
  motifCS_OD: "data.fk_id_examen === 2",
  RED_BOLD: (params) => {
    if (params.data.fk_id_examen === 11) {
      let x = params.value;
      let result1 = x.slice(3, 5);
      let result2 = x.slice(19, 22);
      result1 = parseInt(result1);
      result2 = parseInt(result2);
      if (result1 > 21 || result2 < 500) {
        return true;
      }
    }
  },
};

let isHeaderRow = (params) => {
  return params.data.fk_id_examen === 6;
};

let isQuarterRow = (params) => {
  if (params.data.fk_id_examen === 1) {
    return true;
  } else if (params.data.fk_id_examen === 14) {
    return true;
  } else if (params.data.fk_id_examen === 15) {
    return true;
  } else if (params.data.fk_id_examen === 2) {
    return true;
  } else {
    return false;
  }
};

export const columnDefsConsultation = [
  {
    headerName:
      "Cliquer sur la flèche pour basculer entre l'affichage Basic ou Détaillé",
    groupId: "PersonalGroup",
    children: [
      {
        headerName: "fk_id_patientConsul",
        field: "fk_id_patientConsul",

        hide: true,
      },
      {
        headerName: "fk_id_examen",
        field: "fk_id_examen",

        hide: true,
      },
      {
        headerName: "Examen",
        // field: 'nom_examen',
        valueGetter: ({ data }) => {
          if (data.fk_id_examen === 6) {
            return data.tempsConsultation;
          } else {
            return data.nom_examen;
          }
        },
        editable: false,
        width: 150,
        // suppressSizeToFit: false,
        // checkboxSelection: true,
        minWidth: 150,
        maxWidth: 200,
        checkboxSelection: (params) => {
          if (isHeaderRow(params)) {
            return false;
          } else {
            return true;
          }
        },
        filterParams: {
          defaultOption: "startsWith",
        },
        cellClassRules: cellClassRules,
        colSpan: (params) => {
          if (isHeaderRow(params)) {
            return 10;
          } else {
            return 1;
          }
        },
      },

      {
        cellStyle: { "whiteSpace": "normal", "lineHeight": 2 },
        headerName: "OD",
        field: "od",
        cellClassRules: cellClassRulesODG,
        filterParams: {
          defaultOption: "startsWith",
        },
        colSpan: (params) => {
          if (isQuarterRow(params)) {
            return 2;
          } else {
            return 1;
          }
        },
      },
      {
        headerName: "OG",
        field: "og",
        filterParams: {
          defaultOption: "startsWith",
        },
        cellClassRules: cellClassRulesODG,
      },
      {
        cellClassRules: cellClassRulesODG,
        headerName: "Observation",
        field: "observation",
        filterParams: {
          defaultOption: "startsWith",
        },
      },
      {
        headerName: "Créée le",
        field: "created_at",
        filter: "agDateColumnFilter",
        filterParams: filterParams,
        // sortable: true,
        editable: false,
        columnGroupShow: "open",
        comparator: dateComparator,
      },
      {
        headerName: "Créée par",
        field: "created_by",
        // sortable: true,
        editable: false,
        filterParams: {
          defaultOption: "startsWith",
        },
        columnGroupShow: "open",
      },
      {
        headerName: "Modifié le",
        field: "updated_at",
        filter: "agDateColumnFilter",
        filterParams: filterParams,
        // sortable: true,
        editable: false,
        columnGroupShow: "open",
        comparator: dateComparator,
      },
      {
        headerName: "Modifié par",
        // sortable: true,
        editable: false,
        field: "updated_by",
        filterParams: {
          defaultOption: "startsWith",
        },
        columnGroupShow: "open",
      },
    ],
  },
];

export const defaultColDefConsultation = {
  suppressMovable: true,
  // sortable: true,
  editable: true,
  cellEditor: 'agLargeTextCellEditor',
  cellEditorPopup: true,
  cellEditorParams: {
    maxLength: '3000',
    cols: '40',
    rows: '6',
  },
  maxLength: 1000,
  flex: 1,
  // filter stuff
  filter: true,
  // floatingFilter: true,
  // suppressMenu: true,
  // end of filter stuff
  minWidth: 100,
  // resizable: true,
  // tooltipComponent: 'customTooltip',
  filterParams: {
    newRowsAction: "keep",
    // buttons: ['apply', 'clear'],
  },
  resizable: true,
  cellClass: "cell-wrap-text",
  autoHeight: true,
};
